import axios from 'axios';

const api = axios.create({
    baseURL: "https://abrahub.com.br/api"
});

export default api;